import i18n from '@/i18n';

const state = {
  availableCountries: [
    { code: 'DE', searchType: 'kba' },
    { code: 'AT', searchType: 'vin' },
    { code: 'PL', searchType: 'vin' },
    { code: 'CH', searchType: 'vin' },
    { code: 'BE', searchType: 'vin' },
    { code: 'DK', searchType: 'licensePlate' },
    { code: 'FI', searchType: 'licensePlate' },
    { code: 'NL', searchType: 'licensePlate' },
    { code: 'NO', searchType: 'licensePlate' },
    { code: 'SE', searchType: 'licensePlate' },
    { code: 'ES', searchType: 'licensePlate' },
    { code: 'GB', searchType: 'licensePlate' },
    { code: 'FR', searchType: 'licensePlate' }
  ],
  selectedCountry: null
};

const getters = {
  availableCountriesOptions: state =>
    state.availableCountries.map(country => {
      return {
        value: country.code,
        label: i18n.t(`countries.${country.code.toLowerCase()}FullName`)
      };
    }).sort((a, b) => a.label.localeCompare(b.label))
};

const mutations = {
  SET_SELECTED_COUNTRY (state, payload) {
    state.selectedCountry = payload;
  }
};

const actions = {
  SET_SELECTED_COUNTRY ({ commit }, payload) {
    commit('SET_SELECTED_COUNTRY', payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
